// extracted by mini-css-extract-plugin
module.exports = {"resourceRow":"ResourcesDataCell_resourceRow__3DJtG","resource":"ResourcesDataCell_resource__129dE","LINK":"ResourcesDataCell_LINK__3ugEA","PDF":"ResourcesDataCell_PDF__cMu55"};